import { css } from '@emotion/react';
import { useLayoutEffect } from 'react';

import { useWebAppSettings } from '../store/web-app-settings/useWebAppSettings';

import { cssClass } from './cssClass';
import { su } from './functions/su';
import { motion } from './motion';
import { theme } from './theme';

export function GlobalStyles() {
  const { settings } = useWebAppSettings();

  const { theme } = settings;
  useLayoutEffect(() => {
    if (theme.darkMode === true) {
      document.documentElement.classList.remove(cssClass.lightTheme);
      document.documentElement.classList.add(cssClass.darkTheme);
      document.getElementsByName('theme-color')[0].setAttribute('content', '#222329');
    } else {
      document.documentElement.classList.remove(cssClass.darkTheme);
      document.documentElement.classList.add(cssClass.lightTheme);
      document.getElementsByName('theme-color')[0].setAttribute('content', '#ffffff');
    }
  }, [theme.darkMode]);

  useLayoutEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    function apply(isReduced) {
      document.documentElement.classList.toggle(cssClass.reducedMotion, isReduced);
    }

    apply(mediaQuery.matches);

    function handleChange(event) {
      apply(event.matches);
    }

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return null;
}

export const input = css`
  color: ${theme.color.text};
  caret-color: ${theme.color.mono_1000};
  background: ${theme.color.component};
  border: 1px solid ${theme.color.line};
  border-radius: ${theme.input.border_radius};
  transition: border-color ${motion.duration.fast} ${motion.curve.fast_in};
  min-height: var(--height, ${su(4)});

  &::placeholder {
    color: ${theme.color.mono_300};
  }

  &:hover {
    border-color: ${theme.input.border_hover};
    box-shadow: ${theme.input.box_shadow_hover};
  }

  &:focus {
    border-color: ${theme.input.border_focus};
    box-shadow: ${theme.input.box_shadow_focus};
  }

  &[data-has-error='true'] {
    border-color: ${theme.input.border_error};
    box-shadow: ${theme.boxShadow.error};
  }
`;
